import { Link, useLocation } from "react-router-dom";
import { useSite } from "../site/SiteContext";

export function PrimaryButton({ children, href, onClick, testId, className = "" }) {
  const { applyHref } = useSite();
  const { pathname } = useLocation();
  const target = href || applyHref(pathname);
  const cls = `inline-block rounded-full bg-pink px-8 py-4 text-base font-bold text-white shadow-[0_8px_24px_-6px_rgba(242,0,94,0.45)] transition-[background-color,box-shadow,transform] duration-200 hover:bg-pink-dark hover:shadow-[0_12px_28px_-4px_rgba(242,0,94,0.55)] active:scale-[0.98] ${className}`;
  if (target.startsWith("/")) {
    return <Link to={target} onClick={onClick} data-testid={testId} className={cls}>{children}</Link>;
  }
  return <a href={target} onClick={onClick} data-testid={testId} className={cls}>{children}</a>;
}

export function SecondaryButton({ children, href, onClick, testId, className = "", light = false }) {
  const tone = light
    ? "border-white text-white hover:bg-white hover:text-navy"
    : "border-navy text-navy hover:bg-navy hover:text-white";
  return (
    <a
      href={href}
      onClick={onClick}
      data-testid={testId}
      className={`inline-block rounded-full border-2 px-8 py-4 text-base font-bold transition-[background-color,color,transform] duration-200 active:scale-[0.98] ${tone} ${className}`}
    >
      {children}
    </a>
  );
}

export function CTABand({ title = "Want numbers like these on your account?", sub }) {
  return (
    <section data-testid="cta-band" className="bg-navy">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-5 py-16 md:flex-row md:items-center md:justify-between">
        <div className="max-w-xl">
          <h2 className="text-[26px] font-bold leading-[1.15] text-white md:text-[32px]">{title}</h2>
          {sub && <p className="mt-3 text-base text-white/70">{sub}</p>}
        </div>
        <PrimaryButton testId="cta-band-work-with-us-btn">Work with us</PrimaryButton>
      </div>
    </section>
  );
}
